import wintradoDevConfig from './wintrado.dev';
import getFullConfigFromBrandConfig from './base';
const baseBrandConfig = getFullConfigFromBrandConfig(wintradoDevConfig, 'dev');
const config = Object.assign(Object.assign({}, baseBrandConfig), { oAuth: Object.assign(Object.assign({}, baseBrandConfig.oAuth), { clientId: 'webtrader-local', clientSecret: 'RZP9tlYA4pFiKfH7' }) });
export default config;
